import { generateClient } from 'aws-amplify/api';
import * as mutations from '../graphql/mutations';
import * as queries from '../graphql/queries';

const client = generateClient();

/**
 * Updates a user's training pathway
 * @param {string} profileId - The ID of the user profile to update
 * @param {string} trainingPath - The selected training path (IMT, CST, or ACCS)
 * @returns {Promise} - The GraphQL mutation result
 */
export const updateTrainingPathway = async (profileId, trainingPath) => {
  try {
    console.log('Updating training pathway for profile:', profileId, 'to:', trainingPath);
    
    const input = {
      id: profileId,
      trainingPath: trainingPath,
      updatedAt: new Date().toISOString()
    };

    const result = await client.graphql({
      query: mutations.updateUserProfile,
      variables: { input },
      authMode: 'userPool'
    });

    console.log('Training pathway update successful:', result);
    return result;
  } catch (error) {
    console.error('Error updating training pathway:', error);
    throw error;
  }
};

/**
 * Fetches a user's training pathway
 * @param {string} username - The username of the user
 * @returns {Promise<string>} - The user's training pathway or null if not found
 */
export const fetchTrainingPathway = async (username) => {
  try {
    console.log('Fetching training pathway for user:', username);
    
    const { data } = await client.graphql({
      query: queries.listUserProfiles,
      variables: {
        filter: { owner: { eq: username } }
      },
      authMode: 'userPool'
    });
    
    if (data.listUserProfiles.items.length > 0) {
      const profile = data.listUserProfiles.items[0];
      return profile.trainingPath || 'IMT'; // Default to IMT if not set
    }
    
    console.log('No profile found for user:', username);
    return 'IMT'; // Default value
  } catch (error) {
    console.error('Error fetching training pathway:', error);
    return 'IMT'; // Default to IMT on error
  }
};
